import { Card } from '@/components'
import { Skeleton } from '@mui/material'
import Image from 'next/image'
import Link from '@/features/ref/components/Link'
import React from 'react'

export const CardWrapProduct = ({
  children,
  direction,
  responsive,
  badge,
  img,
}: {
  children: React.ReactNode
  direction: 'GRID' | 'COLUMN'
  responsive?: boolean
  badge?: React.ReactNode[]
  img: {
    link: string
    src: string
    size: 'small' | 'default' | 'large'
  }
}) => {
  return (
    <Card
      direction={direction}
      className={`group relative flex flex-col transition duration-500 ${responsive ? 'responsive' : ''}`}
      cover={<ImageCover {...img} />}
      badge={badge}
    >
      {children}
    </Card>
  )
}

const ImageCover = ({
  link,
  src,
  size,
}: {
  link: string
  src: string
  size: 'small' | 'default' | 'large'
}) => {
  return (
    <div
      className="relative w-full rounded-md p-2 "
      style={{
        display: 'block',
      }}
    >
      <div className="group-hover:[&_img]:duration-400 relative h-48 p-1 group-hover:[&_img]:scale-105 group-hover:[&_img]:transition-all">
        {src ? (
          <Link href={link} prefetch>
            <Image
            
              className="duration-400 mx-auto h-full object-contain transition-all"
              src={src}
              width={500}
              height={500}
              style={{
                maxWidth: size == 'small' ? '8rem' : '10rem',
                width: '100%',
              }}
              alt=""
            />
          </Link>
        ) : (
          <Skeleton className="!h-[150px]" animation="wave" />
        )}
      </div>
    </div>
  )
}
